var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { call, put, take, takeEvery, takeLatest } from 'redux-saga/effects';
import getConfig from '../config';
import * as actions from '../constants/actionTypes';
import callApi from '../graphql/callApi';
import sagaFactory from '../utils/sagaFactory';
import getStripe from '../utils/stripe';
var config = getConfig();
export var applyPromoCode = sagaFactory('applyPromoCode', actions.applyPromoCode, callApi.applyPromoCode, 'applyPromoCode', { delay: 300 });
export var applyPartnerPromoCode = sagaFactory('applyPartnerPromoCode', actions.applyPartnerPromoCode, callApi.applyPartnerPromoCode, 'applyPartnerPromoCode', { delay: 300 });
export var getPaymentIntent = sagaFactory('getPaymentIntent', actions.getPaymentIntent, callApi.createPaymentIntent, 'createPaymentIntent');
export function createSubscription(_a) {
    var response, err_1, message;
    var _b;
    var payload = _a.payload, next = _a.next;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 5, , 7]);
                return [4 /*yield*/, call(callApi.createSubscription, payload)];
            case 1:
                response = _c.sent();
                if (!((_b = response.data) === null || _b === void 0 ? void 0 : _b.createSubscription)) return [3 /*break*/, 3];
                if (next) {
                    next(response.data.createSubscription.clientSecret);
                }
                return [4 /*yield*/, put({
                        payload: response.data.createSubscription,
                        type: actions.createSubscription.type.SUCCESS,
                    })];
            case 2:
                _c.sent();
                return [3 /*break*/, 4];
            case 3: throw new Error('Get payment intent fail');
            case 4: return [3 /*break*/, 7];
            case 5:
                err_1 = _c.sent();
                message = err_1.message;
                console.error('createSubscription', message);
                return [4 /*yield*/, put({
                        type: actions.createSubscription.type.FAILED,
                        payload: message,
                    })];
            case 6:
                _c.sent();
                if (next) {
                    next(false, message);
                }
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
export function makePayment(_a) {
    var cardElement, clientSecret, paymentMethodId, stripe, cardPaymentOption, response, err_2, message;
    var payload = _a.payload;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 7, , 9]);
                cardElement = payload.cardElement, clientSecret = payload.clientSecret, paymentMethodId = payload.paymentMethodId;
                return [4 /*yield*/, getStripe()];
            case 1:
                stripe = _b.sent();
                cardPaymentOption = void 0;
                if (paymentMethodId) {
                    cardPaymentOption = {
                        payment_method: paymentMethodId,
                        payment_method_options: {
                            card: {
                                cvc: cardElement,
                            },
                        },
                    };
                }
                else {
                    cardPaymentOption = {
                        payment_method: {
                            card: cardElement,
                        },
                    };
                }
                return [4 /*yield*/, call(stripe.confirmCardPayment, clientSecret, cardPaymentOption)];
            case 2:
                response = _b.sent();
                if (!response.error) return [3 /*break*/, 4];
                return [4 /*yield*/, put({ type: actions.makePayment.type.FAILED, payload: response.error.message })];
            case 3:
                _b.sent();
                return [3 /*break*/, 6];
            case 4: return [4 /*yield*/, put({ type: actions.makePayment.type.SUCCESS, payload: response.paymentIntent })];
            case 5:
                _b.sent();
                _b.label = 6;
            case 6: return [3 /*break*/, 9];
            case 7:
                err_2 = _b.sent();
                message = err_2.message;
                console.error('makePayment', err_2);
                return [4 /*yield*/, put({ type: actions.makePayment.type.FAILED, payload: message })];
            case 8:
                _b.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
export function createSubscriptionAndPay(_a) {
    var subscription, clientSecret, makePaymentResp, err_3, message;
    var _b;
    var payload = _a.payload, next = _a.next;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 9, , 11]);
                return [4 /*yield*/, put({
                        type: actions.createSubscription.type.REQUEST,
                        payload: {
                            priceId: config.subscriptionPriceId,
                        },
                    })];
            case 1:
                _c.sent();
                return [4 /*yield*/, take([
                        actions.createSubscription.type.SUCCESS,
                        actions.createSubscription.type.FAILED,
                    ])];
            case 2:
                subscription = _c.sent();
                if (subscription.type === actions.getPaymentIntent.type.FAILED) {
                    throw new Error(subscription.payload);
                }
                clientSecret = subscription.payload.clientSecret;
                if (!clientSecret) return [3 /*break*/, 7];
                return [4 /*yield*/, put({
                        type: actions.makePayment.type.REQUEST,
                        payload: {
                            cardElement: payload.cardElement,
                            clientSecret: clientSecret,
                            paymentMethodId: (_b = payload.paymentMethod) === null || _b === void 0 ? void 0 : _b.id,
                        },
                    })];
            case 3:
                _c.sent();
                return [4 /*yield*/, take([
                        actions.makePayment.type.SUCCESS,
                        actions.makePayment.type.FAILED,
                    ])];
            case 4:
                makePaymentResp = _c.sent();
                if (makePaymentResp.type === actions.makePayment.type.FAILED) {
                    throw new Error(makePaymentResp.payload);
                }
                return [4 /*yield*/, put({
                        type: actions.createSubscriptionAndPay.type.SUCCESS,
                    })];
            case 5:
                _c.sent();
                next(true);
                return [4 /*yield*/, put({
                        type: actions.refresh.type.REQUEST,
                    })];
            case 6:
                _c.sent();
                console.log('++ 4 ++');
                return [3 /*break*/, 8];
            case 7: throw new Error('Get payment intent fail');
            case 8: return [3 /*break*/, 11];
            case 9:
                err_3 = _c.sent();
                message = err_3.message;
                console.error('createSubscriptionAndPay', message);
                return [4 /*yield*/, put({
                        type: actions.createSubscriptionAndPay.type.FAILED,
                        payload: message,
                    })];
            case 10:
                _c.sent();
                next(false, message);
                return [3 /*break*/, 11];
            case 11: return [2 /*return*/];
        }
    });
}
export var getPartnerPaymentIntent = sagaFactory('getPartnerPaymentIntent', actions.getPartnerPaymentIntent, callApi.createPartnerPaymentIntent, 'createPartnerPaymentIntent');
function paymentSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(actions.applyPromoCode.type.REQUEST, applyPromoCode)];
            case 1:
                _a.sent();
                return [4 /*yield*/, takeLatest(actions.applyPartnerPromoCode.type.REQUEST, applyPartnerPromoCode)];
            case 2:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.getPaymentIntent.type.REQUEST, getPaymentIntent)];
            case 3:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.getPartnerPaymentIntent.type.REQUEST, getPartnerPaymentIntent)];
            case 4:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.makePayment.type.REQUEST, makePayment)];
            case 5:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.createSubscription.type.REQUEST, createSubscription)];
            case 6:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.createSubscriptionAndPay.type.REQUEST, createSubscriptionAndPay)];
            case 7:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export default paymentSaga;
//# sourceMappingURL=payment.js.map